import Navbar from "@/components-library/widgets/navbar";
import { Switch, Route } from "react-router-dom";
import BuildYourSolution from "@/views/build-your-solution/";
import AnnouncementDetail from "@/common/components/announcement-detail";
import classes from "./app.module.scss";
import { BrowserRouter as Router } from "react-router-dom";
import Flex from "@/components-library/layout/flex";
import Header from "@/views/header";
import Footer from "@/views/footer/footer";
import ScrollToTop from "@/components-library/widgets/scroll-to-top";
import AdminDashboard from "@/views/admin-dashboard/init";
import Cookies from "./cookies/cookies";
import { Account } from "@/views/admin-dashboard/login/account";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import * as annoucementSlice from "../views/build-your-solution/build-your-solution.slice";
import VisuraToExcel from "@/views/admin-dashboard/visura-to-excel/init";
import InitAnnoucement from "@/views/admin-dashboard/create-announcement/init-annoucement";
import LoadTechnicalPdf from "@/views/admin-dashboard/load-technical-pdf";
import { LINKS } from "@/static-texts/links";
import { STATIC_PAGES } from "@/static-texts/static-pages-list";

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    const handleTabClose = () => {
      dispatch(annoucementSlice.clearState());
      return;
    };
    window.addEventListener("beforeunload", handleTabClose);
    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Router>
      <Header />
      <Navbar />
      <Flex justify="center" align="center" className={classes.container}>
        <ScrollToTop />
        <Switch>
          {STATIC_PAGES.map(({ path, Page }) => (
            <Route path={path} key={path} exact>
              {Page}
            </Route>
          ))}
          <Route path="/admin/6484ec7b" exact>
            <Account>
              <AdminDashboard />
            </Account>
          </Route>
          <Route path="/admin/create-announcement/:id" exact>
            <InitAnnoucement />
          </Route>
          <Route path="/:role/announcement-detail/:id">
            <AnnouncementDetail />
          </Route>
          <Route path={LINKS.BUILD_YOUR_SOLUTION} exact>
            <BuildYourSolution />
          </Route>
          <Route path="/admin/6484ec7b/visura">
            <Account>
              <VisuraToExcel />
            </Account>
          </Route>
          <Route path="/admin/6484ec7b/load-pdf">
            <Account>
              <LoadTechnicalPdf />
            </Account>
          </Route>
        </Switch>
      </Flex>
      <Footer />
      <Cookies />
    </Router>
  );
}

export default App;
